import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-63a9a83e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "hero-section",
    class: "hero"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "hero-orbit hero-orbit--one",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "hero-orbit hero-orbit--two",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_4 = { class: "site-container hero-grid" };
const _hoisted_5 = /*#__PURE__*/ _createStaticVNode("<div class=\"hero-copy\" data-v-63a9a83e><div class=\"hero-kicker\" data-v-63a9a83e><span data-v-63a9a83e>Estudio notarial</span><i data-v-63a9a83e></i><span data-v-63a9a83e>Montevideo</span></div><h1 data-v-63a9a83e>Decisiones importantes.<br data-v-63a9a83e><em data-v-63a9a83e>Respuestas claras.</em></h1><p data-v-63a9a83e> Acompañamiento notarial personal para resolver cada gestión con seguridad, criterio y sin vueltas innecesarias. </p><div class=\"hero-actions\" data-v-63a9a83e><a href=\"tel:+59899943824\" class=\"hero-secondary\" data-v-63a9a83e><span class=\"hero-secondary__icon\" aria-hidden=\"true\" data-v-63a9a83e><svg viewBox=\"0 0 24 24\" fill=\"none\" data-v-63a9a83e><path d=\"M7.1 4.5 9.4 4a1.4 1.4 0 0 1 1.6.9l.9 2.5a1.4 1.4 0 0 1-.4 1.5l-1.3 1.2a12.2 12.2 0 0 0 3.7 3.7l1.2-1.3a1.4 1.4 0 0 1 1.5-.4l2.5.9a1.4 1.4 0 0 1 .9 1.6l-.5 2.3a2.6 2.6 0 0 1-2.5 2C10.4 18.9 5.1 13.6 5.1 7a2.6 2.6 0 0 1 2-2.5Z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-63a9a83e></path></svg></span><span class=\"hero-secondary__copy\" data-v-63a9a83e><small data-v-63a9a83e>Contacto directo</small><strong data-v-63a9a83e>099 943 824</strong></span></a></div><div class=\"hero-proof\" data-v-63a9a83e><div data-v-63a9a83e><strong data-v-63a9a83e>25+</strong><span data-v-63a9a83e>años de experiencia</span></div><div data-v-63a9a83e><strong data-v-63a9a83e>1 a 1</strong><span data-v-63a9a83e>atención directa</span></div><div data-v-63a9a83e><strong data-v-63a9a83e>100%</strong><span data-v-63a9a83e>confidencial</span></div></div></div>", 1);
const _hoisted_6 = {
    class: "hero-visual",
    "aria-label": "Información del estudio"
};
const _hoisted_7 = { class: "studio-card" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "studio-card__top" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Mary Iglesias"),
    /*#__PURE__*/ _createElementVNode("small", null, "Escribana Pública")
], -1));
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "studio-card__statement" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "“"),
    /*#__PURE__*/ _createElementVNode("p", null, "Entender bien es el primer paso para decidir mejor.")
], -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "studio-card__address" }, [
    /*#__PURE__*/ _createElementVNode("small", null, "Nueva dirección"),
    /*#__PURE__*/ _createElementVNode("strong", null, "Bulevar España 2059, apto. 104"),
    /*#__PURE__*/ _createElementVNode("span", null, "esquina Blanes · Montevideo")
], -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "folio-card" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "MI"),
    /*#__PURE__*/ _createElementVNode("small", null, [
        /*#__PURE__*/ _createTextVNode("Estudio"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("Notarial")
    ])
], -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "site-container matter-strip" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Compraventas"),
    /*#__PURE__*/ _createElementVNode("span", null, "Certificaciones"),
    /*#__PURE__*/ _createElementVNode("span", null, "Sucesiones"),
    /*#__PURE__*/ _createElementVNode("span", null, "Poderes"),
    /*#__PURE__*/ _createElementVNode("span", null, "Sociedades"),
    /*#__PURE__*/ _createElementVNode("span", null, "Autorizaciones")
], -1));
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeroSection',
    setup(__props) {
        const logo = new URL('@/assets/notarial-logo.png', import.meta.url).href;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("img", {
                                src: _unref(logo),
                                alt: ""
                            }, null, 8, _hoisted_9),
                            _hoisted_10,
                            _hoisted_11
                        ]),
                        _hoisted_12
                    ])
                ]),
                _hoisted_13
            ]));
        };
    }
});
